import {Injectable} from '@angular/core';
import {MockBackend} from '@angular/http/testing';
import {Response, ResponseOptions} from '@angular/http';

// Classes
import {ProductCategory} from '../classes/product-category';

// Config
import {CONFIG} from '../../../../config/config';

// Data
import {productCategories} from '../data/product-categories';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductCategoriesMockApi'));
declare let _: any;

/**
 * Simulates the server Product categories API.
 * Creates a fake database using the `app/data` files.
 * Responds to connection requests via the API.
 * Should be disabled by commenting import statements in the app-modules.ts after server API is online.
 */
@Injectable()
export class ProductCategoriesMockApi {

    private _categories: ProductCategory[] = [];

    
    constructor (
        private _mockBackend: MockBackend
    ) {
        // 'Construct Products categories mock api' );
        this._setupMockProductCategoriesDb();
        this._setupMockConnections();
    }

    
    private _setupMockProductCategoriesDb () {
        // 'Setup Products categories mock database' );

        let uuid: number = 0;

        // Fill with vspaData
        productCategories.forEach(
            (productCategoryCfg: any) => {

                // Create new product category
                let productCategory = new ProductCategory({
                    _uuid: uuid++,
                    id: productCategoryCfg.id,
                    parentCategoryId: productCategoryCfg.parentCategoryId,
                    menuName: productCategoryCfg.menuName,
                    title: productCategoryCfg.title,
                    subtitle: productCategoryCfg.subtitle,
                    shortDescription: productCategoryCfg.shortDescription,
                    longDescription: productCategoryCfg.longDescription,
                    techSpecsLink: productCategoryCfg.techSpecsLink,
                    image: productCategoryCfg.image,
                    renderMode: productCategoryCfg.renderMode,
                    customRenderer: productCategoryCfg.customRenderer,
                    isVisible: productCategoryCfg.isVisible,
                    allowInCartMultipleProds: productCategoryCfg.allowInCartMultipleProds,
                    sortOrder: productCategoryCfg.sortOrder,
                    zIndex: productCategoryCfg.zIndex
                });

                // Store in mock database
                this._categories.push( productCategory );
            }
        );

        debugOff( 'Product categories:', this._categories );
    }

    
    private _setupMockConnections () {
        // 'Setup mock connections' );

        this._mockBackend.connections.subscribe( connection => {
            // 'Mock server response' );

            let singleCategoryMatcher = /\/api\/category\/([0-9]+)/i;
            let domain = CONFIG.domain;

            // Debug
            debugOff( 'Request url:', connection.request.url );
            debugOff( 'Request method:', connection.request.method );

            // Return all categories
            // GET: /category
            if (connection.request.url === domain + 'api/category' &&
                connection.request.method === 0
            ) {
                this._getAllCategories( connection );
            }
            
            // Return category matching the given id
            // GET: /category/:id
            else if (connection.request.url.match( singleCategoryMatcher ) &&
                connection.request.method === 0
            ) {
                this._getCategoryById( connection );
            }
            
            // Add or update a category
            // POST: /category
            else if (connection.request.url === domain + 'api/category'
                && connection.request.method === 1
            ) {
                this._postCategory( connection );
            }
            
            // Delete a category
            // DELETE: /category/:id
            else if (connection.request.url.match( singleCategoryMatcher ) &&
                connection.request.method === 3
            ) {
                this._deleteCategory( connection );
            }

        });
    }

    
    private _getAllCategories (connection) {
        debugOff( 'Get all categories' );

        let response = new Response( new ResponseOptions({
            body: JSON.stringify( this._categories )
        }));

        debugOff( 'Mock response:', response );

        connection.mockRespond( response );
    }

    
    private _getCategoryById (connection) {
        debugOff( 'Get category by id' );

        let singleCategoryMatcher = /\/api\/category\/([0-9]+)/i,
            matches = this._categories.filter( category => {
                return category._uuid == connection.request.url.match( singleCategoryMatcher )[1]
            }),
            response = new Response( new ResponseOptions({
                body: JSON.stringify( matches[0] )
            }));

        connection.mockRespond( response );
    }

    
    private _postCategory (connection) {let newCategory: ProductCategory = JSON.parse( connection.request._body );
        debugOff( 'Post category' );

        let existingCategory = this._categories.filter(
            (category: ProductCategory) => { return category._uuid == newCategory._uuid }
        );

        if (existingCategory && existingCategory.length === 1) {

            // Update existing category
            Object.assign( existingCategory[0], newCategory );

            let response = new Response( new ResponseOptions({
                body: JSON.stringify( existingCategory[0] )
            }));

            connection.mockRespond( response );
        } else {

            // Create new category
            newCategory._uuid = parseInt(
                    _.max( this._categories, category => { return category._uuid; } )._uuid || 0, 10
                ) + 1;

            this._categories.push( newCategory );

            let response = new Response( new ResponseOptions({
                body: JSON.stringify( newCategory )
            }));

            connection.mockRespond( response );
        }
    }

    
    private _deleteCategory ( connection ) {
        debugOff( 'Delete category' );

        let singleCategoryMatcher = /\/api\/category\/([0-9]+)/i,
            categoryId = connection.request.url.match( singleCategoryMatcher )[1],
            position = _.indexOf( _.pluck(this._categories, '_uuid'), categoryId );

        this._categories.splice( position, 1 );

        let response = new Response( new ResponseOptions({
            body: JSON.stringify({})
        }));

        connection.mockRespond( response );
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/mock-product-categories-api.ts